<template>
  <div>
    <!-- in sbpps lc print view <br />
    lc_data--{{ lc_data }} <br /> -->
    <!-- org_basic_data--{{ org_basic_data }} <br /> -->
    <div id="document1" class="printdiv">
      <div class="header">
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
          </v-col>

          <v-col cols="12" sm="9" md="9">
            <center>
              <h3 class="trust-name" style="margin-right: 12%">
                {{ org_basic_data.trust_name }}
              </h3>
              <h1 class="schl-name" style="margin-right: 12%">
                {{ org_basic_data.school_name }}
              </h1>
            </center>
            <center>
              <span class="adrs">CBSE Affiliated and NABET Accredited </span>
            </center>
            <center>
              <span class="adrs"
                >Address:&nbsp;{{ org_basic_data.address }}</span
              ><br />

              <span class="adrs" style="margin-right: 0px">
                Contact No.:&nbsp;{{ org_basic_data.phone }}
              </span>
              <span class="adrs" style="margin-left: 5px">
                <v-icon left color="black">mdi-email-outline</v-icon>
                {{ org_basic_data.email }} </span
              ><br />
              <span class="adrs" style="margin-left: 0px; margin-right: 12%"
                >www.sbpatilschool.org</span
              >
            </center>

            <!-- <br /> -->
            <div class="lcheading1">
              <h3 class="stretch2">School Leaving / Transfer Certificate</h3>
            </div>
            <br>
            <center>
                  <p style="font-size: 17px">(No change in any entry in this certificate shall be made except by the authority issuing it and
                   infringement of this requirement is liable to invoice the imposition of penalty such as that of rustication)</p>
            </center>
          </v-col>
        </v-row>
      </div>

      <div class="lcdata">
        <v-col cols="12">
          <v-row dense style="font-weight: bolder">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4"></v-col>
            <v-col align="right" cols="12" md="4" sm="4"
              ><span class="schl-info"
                >UDISE No.:&nbsp;{{ lc_data.udise_no }}</span
              ></v-col
            >
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row dense style="font-weight: bolder">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Sr. No.:&nbsp;{{ lc_data.certificate_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4" align="center"
              ><span class="schl-info"
                >GR No.:{{ lc_data.gr_number }}</span
              ></v-col
            >
            <v-col cols="12" md="4" sm="4" align="right"
              ><span class="schl-info"
                >School Code:&nbsp;{{ lc_data.school_code }}</span
              ></v-col
            >
          </v-row>
        </v-col>

        <!-- lc table content  -->

        <v-col cols="12" sm="12" md="12">
          <v-simple-table id="page">
            <tbody class="tablebody">
              <tr>
                <td>1.</td>
                <td style="width: 49%">Name of the Pupil</td>
                <td class="tdata2">
                  <span> :&nbsp;{{ lc_data.fullname }}</span>
                </td>
              </tr>

              <tr>
                <td>2.</td>
                <td>Mother's Name</td>
                <td class="tdata2">:&nbsp;{{ lc_data.mother_first_name }}</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Father's/Guardian's Name</td>
                <td class="tdata2">:&nbsp;{{ lc_data.father_name }}</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Nationality</td>
                <td class="tdata2">:&nbsp;{{ lc_data.nationality }}</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>
                  Whether the candidate belongs to Schedule Caste or Schedule
                  Tribe or OBC
                </td>
                <td class="tdata2">
                  : <span v-if="lc_data.open_other != null && lc_data.open_other != ''">{{ lc_data.open_other }}, </span>
                  {{ lc_data.religion }}
                  <span v-if="lc_data.caste != null && lc_data.caste != ' '"> - {{ lc_data.caste }}</span>
                  <span v-if="lc_data.sub_caste != null &&lc_data.sub_caste !=' '"> - {{ lc_data.sub_caste }}</span>
                  <span v-if="lc_data.actualcategory">
                    &nbsp;&nbsp; ({{ lc_data.actualcategory }})
                  </span>
                </td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Date of first Admission in the School with class</td>
                <td class="tdata2">
                  :&nbsp;{{ lc_data.doa_edit }}&nbsp;&nbsp;&nbsp;<span
                    v-if="lc_data.admitted_standard"
                  >
                    (&nbsp;{{ lc_data.admitted_standard }}&nbsp;)</span
                  >
                </td>
                <!-- <td class="tdata2">
                  :&nbsp;04-04-2014&nbsp;&nbsp;&nbsp;<span> - I</span>
                </td> -->
              </tr>
              <tr>
                <td>7.</td>
                <!-- <td>
                  Date of Birth According to Admission and Withdrawal Register
                  <br />
                  <span style="font-size: 15px; margin-left: 85%"
                    >(In Figures)</span
                  >
                </td> -->
                <td>
                  Date of Birth According to Admission and Withdrawal Register
                </td>
                <td class="tdata2">
                  :&nbsp;<span style="font-size: 15px">(in Figures)</span>
                  {{ lc_data.dob_fig }}
                </td>
                <!-- <td class="tdata2">
                  :&nbsp;
                  {{ lc_data.dob_fig }}
                </td> -->
              </tr>
              <tr>
                <td></td>
                <td></td>
                <!-- <td>
                  <span style="font-size: 15px; margin-left: 85%"
                    >(In Words)</span
                  >
                </td> -->
                <td class="tdata2">
                  :&nbsp;<span style="font-size: 15px">(in Words)</span>
                  {{ lc_data.dob_words }}
                </td>
                <!-- <td class="tdata2">
                  :&nbsp;
                  {{ lc_data.dob_words }}
                </td> -->
              </tr>
              <tr>
                <td>8.</td>
                <td>Class in which the pupil last studied</td>
                <td class="tdata2">
                  :&nbsp;<span style="font-size: 15px">(in Figures)</span>
                  {{ lc_data.standard }}&nbsp;&nbsp;<span
                    style="font-size: 15px"
                    >(in Words)</span
                  >

                  {{ lc_data.std_in_words }}
                </td>
              </tr>
              <tr>
                <td>9.</td>
                <td>School/Board Annual examination last taken with result</td>
                <td class="tdata2">:&nbsp;{{ lc_data.last_school }}</td>
              </tr>
              <tr>
                <td>10.</td>
                <td>Whether failed, if so, once / twice in the same class</td>
                <td class="tdata2">
                  :&nbsp;  {{ Whether_failed_in_same_class }}
                </td>
              </tr>
              <tr>
                <td>11.</td>
                <td>Subjects Studied</td>
                <td class="tdata2">
                  <!-- :&nbsp;{{ lc_data.courses }} -->
                  <ul
                    style="list-style-type: none"
                    v-for="(course_name, index) in lc_data.courses"
                    :key="index"
                  >
                    <li style="float: left; padding-right: 16px">
                      {{ index + 1 }})
                      {{ course_name.course_name }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>12.</td>
                <td>
                  Whether qualified for promotion to the higher class?
                  <br />
                  If so, to which class
                </td>
                <td class="tdata2">
                  <span v-if="is_promoted_to_next_standard">
                    :&nbsp; {{ is_promoted_to_next_standard.name }}<br
                  /></span>
                  <span v-if="is_promoted_to_next_standard.name === 'Yes'">
                    :&nbsp;<span style="font-size: 15px">(in Figures)</span>
                    &nbsp;&nbsp;
                    {{
                      lc_data.nextstandard.displayname
                    }}&nbsp;&nbsp;&nbsp;<span style="font-size: 15px"
                      >(in Words)</span
                    >
                    &nbsp;&nbsp;{{ lc_data.next_std_in_words }}</span
                  >
                </td>
              </tr>
              <tr>
                <td>13.</td>
                <td>Month up to which the pupil has paid school dues</td>
                <td class="tdata2">:&nbsp;{{ lc_data.receipt_date }}</td>
              </tr>
              <tr>
                <td>14.</td>
                <td>
                  Any fee concession availed of. if so, the nature of such
                  concession
                </td>
                <td class="tdata2">:&nbsp;{{ lc_data.concession }}</td>
              </tr>
              <tr>
                <td>15.</td>
                <td>Total number of working days in the academic session</td>
                <td class="tdata2">
                  :&nbsp;
                  {{ lc_data.total_working_days_sem }}
                </td>
              </tr>
              <tr>
                <td>16.</td>
                <td>
                  Total number of working days pupil present in the school
                  <br />
                  (details may be given)
                </td>
                <td class="tdata2">
                  :&nbsp; {{ lc_data.student_present_days }}
                </td>
              </tr>
              <tr>
                <td>17.</td>
                <td>Whether NCC Cadet/Boy Scout/ Girl Guide</td>
                <td class="tdata2">:&nbsp; {{ lc_data.other_activities }}</td>
              </tr>
              <tr>
                <td>18.</td>
                <td>
                  Games played or extra-curricular activities in which the pupil
                  usually took part (mention achievement level therein):.
                </td>
                <td class="tdata2">
                  :&nbsp;{{ lc_data.extra_curricular_activities }}
                </td>
              </tr>
              <tr>
                <td>19.</td>
                <td>General Conduct</td>
                <td class="tdata2">:&nbsp;{{ lc_data.conduct }}</td>
              </tr>
              <tr>
                <td>20.</td>
                <td>Date of application for this certificate</td>
                <td class="tdata2">:&nbsp;{{ lc_data.date_of_application }}</td>
              </tr>
              <tr>
                <td>21.</td>
                <td>Date of issue of this certificate</td>
                <td class="tdata2">:&nbsp;{{ lc_data.date_of_issue }}</td>
              </tr>
              <tr>
                <td>22.</td>
                <td>Reason for leaving the school</td>
                <td class="tdata2">:&nbsp;{{ lc_data.reason }}</td>
              </tr>
              <tr>
                <td>23.</td>
                <td>Any other remark</td>
                <td class="tdata2">:&nbsp;{{ lc_data.any_other_remark }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <!-- lc table end -->

        <!-- <v-col cols="12" style="font-weight: bolder"> -->
        <br />
        <br />
        <v-row dense style="font-weight: bolder;" class="awss">
          <v-col cols="12" md="4" sm="4" style="padding-left: 38px;">
            <span class="adrs1">Prepared By</span>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <!-- <center> -->
            <span class="adrs1">Checked By</span><br />
            <span class="adrs2">(with full Name & Designation)</span>
            <!-- </center> -->
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <center>
              <!-- {{ org_basic_data.school_name }}<br /> -->
              <span class="adrs1">Signature of Principal</span> <br />
              <span class="adrs2">(with Date & School Seal)</span>
            </center>
          </v-col>
        </v-row>
        <!-- </v-col> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      is_promoted_to_next_standard: "",
      Whether_failed_in_same_class: "",
    };
  },
  methods: {},
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    this.is_promoted_to_next_standard = JSON.parse(localStorage.getItem("is_promoted_to_next_standard")
    );
    this.Whether_failed_in_same_class = JSON.parse(localStorage.getItem("Whether_failed_in_same_class"));
    //alert(this.is_promoted_to_next_standard.name)
  },
};
</script>

<style scoped>
/* lc data css */
.printdiv {
  height: auto;

  width: auto;
}
.header {
  margin: 6px;
}
.trust-name {
  text-transform: uppercase;
  font-size: x-large;
}
.schl-name {
  font-size: 30px;
  text-transform: uppercase;
  font-size: xxx-large;
}

.adrs {
  /* margin-left: 33px; */
  margin-right: 12%;
  font-size: larger;
  font-weight: 500;
}

.lcheading1 {
  margin-left: 16%;
  width: 64%;
  border-radius: 17px;
  border: 1px solid black;
}

.lcheading1 h3 {
  font-size: xx-large;
  margin-left: 18px;
  font-family: Segoe Print;
  font-style: italic;
}
.schlImg {
  width: 84%;
  /* height: 60%; */
  margin-left: 10%;
}
.tdata2 {
  font-weight: bolder;
}

#page tr,
td {
  font-size: medium;
  text-align: left;
}

tbody > tr:hover > td {
  background-color: white !important;
  /* color: white !important; */
}
/* lc data css end */

/* print lc css */
@media print {
  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .adrs {
    /* margin-left: 33px; */
    margin-right: 12%;

    font-size: 22px;
    font-weight: 500;
  }
  .adrs1 {
    font-size: 22px;
    font-weight: 500;
  }

  .adrs2 {
    font-size: 17px;
    font-weight: 500;
  }
  .schlImg {
    width: 84%;
    /* height: 75%; */
  }
  .awss {
    margin-top: 60px;
  }
  .lcheading1 {
    margin-left: 16%;
    width: 60%;
    border-radius: 17px;
    border: 1px solid black;
  }
  @page {
    size: A4;
    /* margin-top: -8px; */
    margin-top: 0px;

    padding-top: none;
    size: 17in 22in;
  }
  .school-code-row{
    text-align: right;
    padding-left: 20px;
    margin-right: 0;
  }
}

.schl-info {
  font-size: 23px;
  font-weight: 500;
}
</style>